import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { Description, Title, TopNavigation } from '@zenterprise-inc/ui';
import cn from 'clsx';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { useLazyLoadQuery } from 'react-relay';

import { leaveUserNameQuery } from '@/__generated__/leaveUserNameQuery.graphql';
import { OngoingRefundButton } from '@/components/my/common/OngoingRefundButton';
import s from '@/components/my/common/layout.module.scss';
import { tryLeaveUserNameQuery } from '@/graphql/query/my/leave';
import { COMMON_PATHS } from '@/lib/constants/paths';

function UnableToLeavePage() {
  const { bznavRefund } = useLazyLoadQuery<leaveUserNameQuery>(tryLeaveUserNameQuery, {});
  const router = useRouter();
  const { sendClickEvent } = useUserEventLogger();

  const goRefundSummaryPage = () => {
    sendClickEvent('delete-before-check_body_in-progress');
    router.push(COMMON_PATHS.환급조회목록);
  };

  const userName = bznavRefund.user.name;

  if (!userName) {
    return <></>;
  }

  return (
    <>
      <TopNavigation.Basic leftIcon={'back'} onLeftClick={() => router.back()} className={s.nav_position} />
      <main className={cn(s.main_content, 'px-4.5')}>
        <article>
          <section>
            <Title.Headline
              title={`${userName}님, 모든 단계가\n완료되어야 탈퇴를 진행할 수 있어요`}
              subText={'모든 단계가 완료되거나 신청을 취소하시면\n비즈넵 환급 탈퇴가 가능해요.'}
              size={'large'}
            />
            <Description.Feedback
              text={'신청 취소는 국세청에서 환급이 결정되기 전까지 가능해요.'}
              status={'info'}
              hasBg={false}
              hasStatusIcon
              hasLinkIcon={false}
            />
            <OngoingRefundButton bg onClick={goRefundSummaryPage} />
          </section>
        </article>
      </main>
    </>
  );
}

UnableToLeavePage.getLayout = (page: ReactElement) => {
  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'delete-before-check'}>{page}</PageViewEventLogger>
    </AuthGuard>
  );
};

export default UnableToLeavePage;
